<template>
  <div class="payment-container">

    <div class="payment-transfer" v-if="type !== 'outstanding'">
      <input
        type="radio"
        class="radio"
        id="'payment_transfer'"
        name="payment_method"
        @change="vPaymentMethod('transfer')"
        :checked="true"
      />
      <label for="'payment_transfer'">
        <span>{{$_('usual_method_of_payment')}}</span>
        <span class="payment-method-libelle usual-payment">{{TLIB_MODP}}</span>
      </label>
    </div>


    <div class="payment-cb" v-if="type === 'outstanding'">
      <input
        type="radio"
        class="radio"
        id="'payment_cb'"
        name="payment_method"
        @change="vPaymentMethod('bankcard_outstanding')"
      />
      <label for="'payment_cb'">
        <span class="payment-method-libelle">{{$_('bank_card')}}</span>
        <img class="payment-method-banner" src="../assets/img/payment-method-banner.png" />
      </label>

      <form :action="payment_url" name="Monetico" method="POST" id="PaymentRequest" ref="payment_form_outstanding">
        <input type="hidden" name="version" :value="version">
        <input type="hidden" name="TPE" :value="TPE">
        <input type="hidden" name="date" :value="date">
        <input type="hidden" name="montant" :value="montant">
        <input type="hidden" name="reference" :value="reference">
        <input type="hidden" name="texte-libre" :value="textelibre">
        <input type="hidden" name="mail" :value="mail">
        <input type="hidden" name="lgue" :value="lgue">
        <input type="hidden" name="societe" :value="societe">
        <input type="hidden" name="url_retour" :value="url_retour">
        <input type="hidden" name="url_retour_ok" :value="url_retour_ok">
        <input type="hidden" name="url_retour_err" :value="url_retour_err">
        <input type="hidden" name="MAC" :value="MAC">
        <input type="hidden" name="options" id="sOptions" value="">
        <input type="hidden" name="3DSecure" value="1">
        <input type="hidden" name="contexte_commande" :value="contexte_commande">
      </form>
    </div>
    <div class="payment-cb" v-else>
      <input
        type="radio"
        class="radio"
        id="'payment_cb'"
        name="payment_method"
        @change="vPaymentMethod('bankcard')"
      />
      <label for="'payment_cb'">
        <span class="payment-method-libelle">{{$_('bank_card')}}</span>
        <img class="payment-method-banner" src="../assets/img/payment-method-banner.png" />
      </label>

      <form :action="payment_url" name="Monetico" method="POST" id="PaymentRequest" ref="payment_form">
        <input type="hidden" name="version" :value="version">
        <input type="hidden" name="TPE" :value="TPE">
        <input type="hidden" name="date" :value="date">
        <input type="hidden" name="montant" :value="montant">
        <input type="hidden" name="reference" :value="reference">
        <input type="hidden" name="texte-libre" :value="textelibre">
        <input type="hidden" name="mail" :value="mail">
        <input type="hidden" name="lgue" :value="lgue">
        <input type="hidden" name="societe" :value="societe">
        <input type="hidden" name="url_retour" :value="url_retour">
        <input type="hidden" name="url_retour_ok" :value="url_retour_ok">
        <input type="hidden" name="url_retour_err" :value="url_retour_err">
        <input type="hidden" name="MAC" :value="MAC">
        <input type="hidden" name="options" id="sOptions" value="">
        <input type="hidden" name="3DSecure" value="1">
        <input type="hidden" name="ThreeDSecureChallenge" value="no_preference">
        <input type="hidden" name="contexte_commande" :value="contexte_commande">
      </form>
    </div>
  </div>
</template>

<script>

import paymentService from '../services/paymentService';

export default {
  name: 'PaymentCB',
  data() {
    return {
      payment_url: '',
      version: '',
      TPE: '',
      date: '',
      montant: 0,
      reference: '',
      textelibre: '',
      mail: '',
      lgue: '',
      societe: '',
      url_retour: '',
      url_retour_ok: '',
      url_retour_err: '',
      contexte_commande: '',
      MAC: '',
      TLIB_MODP: ''
    }
  },
  props: ['type'],
  mounted() {

    this.$store.dispatch('panier/SET', {key: 'payment_ready', value: false})

    this.$store.dispatch('panier/SET', {key: 'payment_method', value: 'transfer'})
    let customer = JSON.parse(localStorage.getItem('satabapp-customer'));
    this.TLIB_MODP = customer.TLIB_MODP;
    this.$emit('mode', {mode: 'transfer'});
    this.vPaymentMethod('transfer')
  },
  methods: {
    vPaymentMethod(mode) {

      this.$store.dispatch('panier/SET', {key: 'payment_ready', value: false})
  
      switch (mode) {
        case 'transfer':
          this.$emit('mode', {mode: 'transfer'});
          this.$store.dispatch('panier/SET', {key: 'payment_ready', value: true})
          break;
        case 'bankcard':
           this.$emit('mode', {mode: 'bankcard'});
          this.getDataBankCard();
          this.$store.dispatch('panier/SET', {key: 'form_cb_ref', value: this.$refs.payment_form});
          break;
        case 'bankcard_outstanding':
           this.$emit('mode', {mode: 'bankcard_outstanding'});
          this.getDataBankCardOutstanding();
          this.$store.dispatch('encour/SET', {key: 'form_cb_outstanding_ref', value: this.$refs.payment_form_outstanding});
          break;
      }

      this.$store.dispatch('panier/SET', {key: 'payment_method', value: mode})
    },
    getDataBankCard() {

      paymentService.getPaymentData()
      .then(res => {
        this.version = res.data.version
        this.TPE = res.data.TPE
        this.date = res.data.date
        this.montant = res.data.montant
        this.reference = res.data.reference
        this.textelibre = res.data['texte-libre']
        this.mail = res.data.mail
        this.lgue = res.data.lgue
        this.societe = res.data.societe
        this.contexte_commande = res.data.contexte_commande
        this.url_retour = res.data.url_retour
        this.url_retour_ok = res.data.url_retour_ok
        this.url_retour_err = res.data.url_retour_err
        this.MAC = res.data.MAC,
        this.payment_url = res.data.payment_url

        this.$store.dispatch('panier/SET', {key: 'payment_ready', value: true})
      })
    },
    getDataBankCardOutstanding() {
    
      paymentService.getPaymentDataOutstanding()
      .then(res => {
        this.version = res.data.version
        this.TPE = res.data.TPE
        this.date = res.data.date
        this.montant = res.data.montant
        this.reference = res.data.reference
        this.textelibre = res.data['texte-libre']
        this.mail = res.data.mail
        this.lgue = res.data.lgue
        this.societe = res.data.societe
        this.contexte_commande = res.data.contexte_commande
        this.url_retour = res.data.url_retour
        this.url_retour_ok = res.data.url_retour_ok
        this.url_retour_err = res.data.url_retour_err
        this.MAC = res.data.MAC,
        this.payment_url = res.data.payment_url

        this.$store.dispatch('panier/SET', {key: 'payment_ready', value: true})
      })
    }
  }
  
}
</script>

<style scoped>
.payment-cb,
.payment-transfer {
  border: solid 1px #E9E9E9;
  padding: 20px;
  margin-bottom: 20px;
}
.payment-method-banner {
  max-width: 300px;
}
.payment-method-libelle {
  display: flex;
  margin-bottom: 15px;
}
.usual-payment {
  margin-top: 20px;
  display: block;
}
</style>